import controller from './pos-enable-modal.controller';
import template from './pos-enable-modal.html';
import './pos-enable-modal.less';

const Component = {
    template,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<',
    },
    controller: ['$state', 'crPosEnableService', 'crErrorLoggingService', controller],
};

export default Component;
